var map = {
	"./responsive/schweizer5-eventlocation-frankfurt-1.jpg": 5,
	"./responsive/schweizer5-eventlocation-frankfurt-2.jpg": 6,
	"./responsive/schweizer5-eventlocation-frankfurt-3.jpg": 7,
	"./responsive/schweizer5-eventlocation-frankfurt-4.jpg": 8,
	"./responsive/schweizer5-eventlocation-frankfurt-5.jpg": 9,
	"./responsive/schweizer5-eventlocation-frankfurt-6.jpg": 10,
	"./responsive/schweizer5-eventlocation-frankfurt-7.jpg": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;